export const floatingMenu = {
  floatingMenuMenu: "菜单",
  floatingMenuHome: "首页",
  floatingMenuGames: "游戏",
  floatingMenuSlots: "老虎机",
  floatingMenuSports: "体育",
  floatingMenuLottery: "彩票",
  floatingMenuCasino: "赌场",
  floatingMenuFeed: "动态",
  floatingMenuBingo: "宾果",
  floatingMenuToPlay: "玩",
  floatingMenuCategories: "类别",
  floatingMenuSeeAllGames: "去所有游戏",
  floatingMenuSeeAllSports: "去所有体育",
};
